import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthorizationService, MagnetService } from '@mirage-projects/cw-commons';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard {
    constructor(
        private authorizationService: AuthorizationService,
        private router: Router,
        private magnetService: MagnetService
    ) {}

    canActivate(): boolean {
        if (this.magnetService.isSite()) {
            return this.canActivateSite();
        } else {
            return this.canActivateWeb();
        }
    }

    canActivateSite(): boolean {
        // TODO: is this correct?
        return true;
    }

    canActivateWeb(): boolean {
        if (this.authorizationService.isUserLogged() || this.magnetService.isEmbed()) {
            return true;
        } else {
            this.router.navigate(['/', 'home']);
            return false;
        }
    }
}
